module.exports = __webpack_public_path__ + "ida_backdrop.jpg?07f7ad565d81477cba2f5655e250b166";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/ida/ida_backdrop.jpg
// module id = 62
// module chunks = 0